<template>
  <div class="itemBox" @mouseenter="showQRCode" @mouseleave="hideQRCode">
    <div class="itemShow" v-show="!showFlag">
      <div class="img">
        <img :src="itemInfoList[hoverIndex-1].img" alt />
      </div>
      <div class="text">{{itemInfoList[hoverIndex-1].text}}</div>
    </div>
    <div class="hoverShow" v-show="showFlag">
      <div class="img">
        <img src="~@/assets/img/footer/qrCode2.png" alt />
      </div>
      <div class="text">
        <div class="top">扫码下载</div>
        <div class="bottom">开启您的掘金之路</div>
      </div>
    </div>
  </div>
</template>
<script>
import sxg1 from "@/assets/img/home/sxg1.png";
import sxg2 from "@/assets/img/home/sxg2.png";
import sxg3 from "@/assets/img/home/sxg3.png";
import sxg4 from "@/assets/img/home/sxg4.png";
import sxg5 from "@/assets/img/home/sxg5.png";
import sxg6 from "@/assets/img/home/sxg6.png";
import sxg7 from "@/assets/img/home/sxg7.png";
import sxg8 from "@/assets/img/home/sxg8.png";
export default {
  name: "hover",
  props: ["hoverIndex"],
  data() {
    return {
      showFlag: false,
      itemInfoList: [
        { img: sxg1, text: "古玩文玩" },
        { img: sxg2, text: "玉器翡翠" },
        { img: sxg3, text: "书法绘画" },
        { img: sxg4, text: "瓷器陶器" },
        { img: sxg5, text: "邮票钱币" },
        { img: sxg6, text: "篆刻奇石" },
        { img: sxg7, text: "铜器银器" },
        { img: sxg8, text: "木器珐琅" }
      ]
    };
  },
  mounted() {
    console.log(this.hoverIndex);
  },
  methods: {
    showQRCode() {
      this.showFlag = true;
    },
    hideQRCode() {
      this.showFlag = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.itemBox {
  width: 235px;
  height: 220px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(204, 204, 204, 0.35);
  // border: 1px solid;
  border-radius: 4px;
  text-align: center;
  .itemShow {
    overflow: hidden;
    .img {
      width: 60px;
      height: 60px;
      margin: 68px auto 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      text-align: center;
      font-size: 20px;
      color: #333333;
      margin-top: 32px;
      line-height: 20px;
    }
  }
  .hoverShow {
    overflow: hidden;
    .img {
      width: 100px;
      height: 100px;
      margin: 32px auto 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      text-align: center;
      overflow: hidden;
      .top {
        font-size: 20px;
        color: #333;
        margin-top: 10px;
        line-height: 20px;
      }
      .bottom {
        font-size: 14px;
        color: #666;
        margin-top: 10px;
        line-height: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/components/hoverItem1.vue